import { useEventsStore } from "@faire/deprecated-retailer-visitor-shared/stores/domain/Events/shared/EventsStore";
import { ICurrentPromotionalEventResponse } from "@faire/web-api--source/indigofair/data/ICurrentPromotionalEventResponse";
import { useStrictLocalization } from "@faire/web/common/localization";
import { getFaireMarketUtils } from "@faire/web/common/promotional-events/getFaireMarketUtils";
import { useMemo } from "react";

export const useMarketRangeDates = () => {
  const { strictLocalize } = useStrictLocalization();
  const { nextOrActive } = useEventsStore();

  const latestMarketEvent = useMemo(() => {
    if (
      nextOrActive?.event?.event_group ===
      ICurrentPromotionalEventResponse.IPromotionalEvent.PromotionalEventGroup
        .MARKET
    ) {
      return nextOrActive;
    }
    return undefined;
  }, [nextOrActive]);

  const marketUtils = useMemo(() => {
    const marketYear = latestMarketEvent?.start_at
      ? new Date(latestMarketEvent.start_at).getFullYear().toString()
      : undefined;
    return getFaireMarketUtils(marketYear, strictLocalize);
  }, [latestMarketEvent, strictLocalize]);

  const latestMarketEarlyAccessRangeDate = useMemo(() => {
    return marketUtils.earlyAccessRangeDate(strictLocalize, latestMarketEvent);
  }, [latestMarketEvent, marketUtils, strictLocalize]);

  const latestMarketMainEventRangeDate = useMemo(() => {
    return marketUtils.mainEventRangeDate(strictLocalize, latestMarketEvent);
  }, [latestMarketEvent, marketUtils, strictLocalize]);

  return { latestMarketEarlyAccessRangeDate, latestMarketMainEventRangeDate };
};
